import { BaseDTO } from '../basedto';
import { PartInfo } from '../partinfo';
import { SearchFilter } from './searchfilter';

export class QueryBaseForPEDTO {
    PEId: number;
}
